import React, {useEffect, useRef, useState} from 'react';
import {AuthLayout} from "../../../core/layout/AuthLayout";
import BtnPrimary from "../../../shared/ui/button/primary/BtnPrimary";
import {FormElements} from "../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../shared/utils/forms/useForm";
import {monthsArrayOpt} from "../../../core/data/date";
import http from "../../../shared/utils/http";
import {useSelector} from "react-redux";
import {selectSelectedPharmacy} from "../../../core/reducer/pharmacySlice";
import {exportPdf} from "../../../shared/utils/exportPdf";
import {dateFormatGG} from "../../../shared/utils/dateUtils";
import {typeHoursInitArray} from "../../../common/typeHours";


export function HoursMany() {
    const pharmacy = useSelector(selectSelectedPharmacy)
    const isTimeBank = !!pharmacy?.timeBank;

    const [data, setData] = useState<any>(undefined);
    const [columns, setColumns] = useState<any>([]);
    const printHandler = () => {
        setPrintView(true)
    }


    const structureDataTypeHour: StructureFormModel[] = [
        {
            type: formControlTypes.select,
            name: "year",
            options: Array.from({length: new Date().getFullYear() - 2024 + 1}, (_, i) => new Date().getFullYear() - i).map(y => ({label: String(y), value: String(y)})),
            dataElement: {
                placeholder: "Seleziona anno",
                type: 'text',
                defaultValue: {label: 'Seleziona Anno', isDefault: true, disabled: true},
            },
            col: {xs: "12", sm: "3"},
        },
        {
            type: formControlTypes.select,
            name: "month",
            options: monthsArrayOpt,
            dataElement: {
                placeholder: "Seleziona mese",
                type: 'text',
                defaultValue: {label: 'Seleziona Mese', isDefault: true, disabled: true},

            },
            col: {sm: "4"},
        },
    ]
    const submitHandler = (event: any, data?: any) => {
        http.get(`pharmacies/${pharmacy?.idDocument}/situation/${data.month}/${data.year}`).then(res => {
            setData(res.infos)
            setColumns(res.columns)
        })
    }
    const {
        dataFormatted,
        dataForm,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitHandler)

    const [printView, setPrintView] = useState<boolean>(false)

    const pdfRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (printView) {
            exportPdf(`${pharmacy?.name}_monte_ore`, pdfRef, () => {
                window.close()
                setPrintView(false)
            })
        }
    }, [printView]);


    return (
        <AuthLayout>
            <div className="row" ref={pdfRef}>
                <div className="col pt-3">
                    <div className={'d-flex justify-content-between align-items-center'}>
                        <div className={'d-flex align-items-center gap-3 w-100'}>
                            <h3 className={'text-nowrap mb-4'}>Monte ore</h3>
                        </div>
                        <div className={'d-flex gap-2 w-100'}>
                            <div className={'ms-auto w-100'}>
                                <FormElements structure={structureDataTypeHour} changeValue={changeValue}
                                              dataForm={dataForm}
                                              style={{justifyContent: 'end'}}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                            {!printView && <div className={'d-flex gap-2'}>
                                <BtnPrimary title="Filtra" icon={'./assets/icons/filter.svg'} disabled={false}
                                            variant={'primary'}
                                            onClick={() => submitAction()}></BtnPrimary>
                                <BtnPrimary title="Stampa" icon={'./assets/icons/print.svg'} disabled={false}
                                            variant={'outline-primary'} className={'text-cyan-500 border-cyan-500'}
                                            onClick={() => printHandler()}></BtnPrimary>
                            </div>}
                        </div>
                    </div>

                    {data ? <div className="col">
                        <table className={'table-print'}>
                            <thead>
                            <tr>
                                <th>Dipendente</th>
                                <th>Ore contratto</th>
                                <th>Tipologia</th>
                                {columns?.map((col: any) => (
                                    <th>{dateFormatGG(col.dateStart)} - {dateFormatGG(col.dateEnd)}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>

                            {data?.map((info: any) => {
                                const arrSpent = typeHoursInitArray.map(ele => ({
                                    label: (ele.timeBank && ele.timeBank !== isTimeBank) ? 'Straordinario' : ele.label,
                                    value: ele.name
                                }))
                                return arrSpent.map((type, i) => <tr style={{borderColor: 'transparent'}}>
                                    {i === 0 &&
                                        <td rowSpan={arrSpent.length}
                                            style={{border: '1px solid gray'}}>{info?.employee.name} {info?.employee.surname}</td>}
                                    {i === 0 &&
                                        <td rowSpan={arrSpent.length}
                                            style={{border: '1px solid gray'}}>{((info.lastWeek?.spentHours[type.value] || 0) / 60).toFixed(2)}</td>}
                                    <td style={{border: '1px solid gray'}}>{type.label}</td>
                                    {columns?.map((col: any) => {
                                        const week = info.weekInfoTotal?.find((w: any) => col.dateStart === w.dateStart)
                                        return <td
                                            style={{border: '1px solid gray'}}>{week ? ((isTimeBank && type.value === 'extraHours' ? (-week?.minutes?.extraHoursEarnWeek || 0) : (week?.spentHours[type.value] || 0)) / 60).toFixed(2) : '-'}
                                            {week && <small
                                                title={'Precedente'}>{type.value === 'extraHours' && isTimeBank ? `(${(week.minutes.extra / 60).toFixed(2)})` : ''}</small>}
                                        </td>
                                    })}
                                </tr>)
                            })}
                            </tbody>
                        </table>
                    </div> : <div>Filtra per anno e mese</div>}
                </div>
            </div>
        </AuthLayout>
    );
}


